import { memo, useCallback } from "react"
import { TriangleAlert } from "lucide-react"
import { Dialog, Modal } from "react-aria-components"

import { noop } from "@be-miniapp/shared/utils/noop"
import { Backdrop } from "@be-miniapp/ui/components/backdrop"
import { Button } from "@be-miniapp/ui/components/ui/button"
import { Typography } from "@be-miniapp/ui/components/ui/typography"
import { cn } from "@be-miniapp/ui/lib/utils"
import { useModalStore } from "@be-miniapp/ui/store/modal"

const ModalOverlay = memo(() => {
  const isShowing = useModalStore((state) => state.show)
  const data = useModalStore((state) => state.data)
  const close = useModalStore((state) => state.close)

  const getIcon = useCallback(() => {
    switch (data?.iconType) {
      case "warning": {
        return (
          <div className="relative size-10 rounded-full bg-red-500/30">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <TriangleAlert size={20} className="text-red-800" />
            </div>
          </div>
        )
      }
      default:
        return null
    }
  }, [data?.iconType])
  return (
    <Modal
      isOpen={isShowing}
      className="fixed inset-0 z-[999999999999] flex items-center justify-center font-display"
      onOpenChange={(isOpen) => {
        !isOpen && close()
      }}
    >
      <Backdrop onBackdropClick={data?.closeOnMaskClick ? close : noop} />
      <Dialog className="z-[200] w-[85%] max-w-[800px] outline-none focus:outline-none">
        <div className="layout-animation rounded-lg bg-white px-5 py-4 duration-300">
          <div className="flex w-full flex-col gap-2">
            {data?.iconType && getIcon()}
            {data?.title && (
              <Typography.Title size="medium" className="text-left">
                {data?.title}
              </Typography.Title>
            )}

            {data?.message && (
              <Typography.Body size="medium" className="font-medium">
                {data?.message}
              </Typography.Body>
            )}
            {data?.primaryLabel && (
              <div
                className={cn(
                  "mt-4 flex w-full items-center gap-2",
                  !data?.buttonOrientation ||
                    data.buttonOrientation === "horizontal"
                    ? "flex-row"
                    : "flex-col gap-3"
                )}
              >
                {data?.secondaryLabel && (
                  <Button
                    className="w-full bg-be-navy-100"
                    onClick={data?.onSecondaryAction}
                  >
                    {data?.secondaryLabel}
                  </Button>
                )}
                <Button
                  className="w-full"
                  onClick={() => {
                    data?.onPrimaryAction?.()
                  }}
                >
                  {data?.primaryLabel}
                </Button>
              </div>
            )}
            {data?.children}
          </div>
        </div>
      </Dialog>
    </Modal>
  )
})

export { ModalOverlay }
